import { AttachmentType } from 'src/app/interfaces/attachment-type';
import { AttachmentTypeLogEvent } from 'src/app/interfaces/log/attachment-type-log';
import { EventLoggingParams, LogEventKey } from '../../../interfaces/log';
import { LogService } from '../log.service';

export class AttachmentTypeLogService {
  constructor(private logService: LogService) {
    
  }

  logHomeAttachmentTestClicked() {
    this.eventLogging(
      AttachmentTypeLogEvent.HOME_ATTACHMENT_TEST_CLICKED
    )
  }
  logAttachmentTestIntroViewed() {
    this.eventLogging(
      AttachmentTypeLogEvent.ATTACHMENT_TEST_INTRO_VIEWED
    )
  }
  // app only
  logAttachmentTestQuestionnareViewed() {
    this.eventLogging(
      AttachmentTypeLogEvent.ATTACHMENT_TEST_QUESTIONNAIRE_VIEWED
    )
  }
  // app only
  logAttachmentTestResultViewed(resultAttachmentType: AttachmentType) {
    this.eventLogging(
      AttachmentTypeLogEvent.ATTACHMENT_TEST_RESULT_VIEWED,
      { resultAttachmentType }
    )
  }
  // app only
  logAttachmentTestShareClicked(resultAttachmentType: AttachmentType) {
    this.eventLogging(
      AttachmentTypeLogEvent.ATTACHMENT_TEST_SHARE_CLICKED,
      { resultAttachmentType }
    )
  }
  // app only
  logAttachmentTestGoToHomeButtonClicked(
    resultAttachmentType: AttachmentType
  ) {
    this.eventLogging(
      AttachmentTypeLogEvent.ATTACHMENT_TEST_GO_TO_HOME_BUTTON_CLICKED,
      { resultAttachmentType }
    )
  }
  // app only
  logAttachmentTestSubmit(stage: number) {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_TEST_SUBMIT, { stage });
  }
  // [홈] ‘애착 유형 퀴즈' 버튼 클릭
  logHomeAttachmentQuizClicked(): void {
    this.eventLogging(AttachmentTypeLogEvent.HOME_ATTACHMENT_QUIZ_CLICKED);
  }
  // [홈] ‘애착 유형 퀴즈' 버튼 노출
  logHomeAttachmentQuizImpression(): void {
    this.eventLogging(AttachmentTypeLogEvent.HOME_ATTACHMENT_QUIZ_IMPRESSION);
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘퀴즈’ 디테일] 호스트 퀴즈 상세로 이동
  logAttachmentQuizHostQuizDetailViewed(): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_QUIZ_DETAIL_VIEWED);
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘퀴즈’ 디테일] web-share-api 공유하기 버튼 클릭
  // replyOnThisQuiz : 해당 퀴즈에 달린 응답의 총 개수
  logAttachmentQuizHostQuizDetailShareWebshareclicked(replyOnThisQuiz: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_QUIZ_DETAIL_SHARE_WEBSHARE_CLICKED, {replyOnThisQuiz});
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘퀴즈’ 디테일] '카톡으로 공유' 버튼 클릭

  logAttachmentQuizHostQuizDetailShareKakaoClicked(replyOnThisQuiz: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_QUIZ_DETAIL_SHARE_KAKAO_CLICKED, {replyOnThisQuiz});
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘퀴즈’ 디테일] 'url 복사' 버튼 클릭
  logAttachmentQuizHostQuizDetailShareURLClicked(replyOnThisQuiz: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_QUIZ_DETAIL_SHARE_URL_CLICKED, {replyOnThisQuiz});
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘응답’ 디테일] 호스트 응답 상세로 이동
  // replyOnThisQuiz : 해당 퀴즈에 달린 응답의 총 개수
  // quizPercentage : 현재 응답의 정답률
  logAttachmentQuizHostReplyDetailViewed(quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_REPLY_DETAIL_VIEWED, {quizPercentage});
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘응답’ 디테일] 이전 버튼 클릭
  logAttachmentQuizHostReplyDetailPrevClicked(stage: number, quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_REPLY_DETAIL_PREV_CLICKED, {stage, quizPercentage});
  }
  // [애착 유형 퀴즈 > 호스트가 보는 ‘응답’ 디테일] 다음 버튼 클릭
  logAttachmentQuizHostReplyDetailNextClicked(stage: number, quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_HOST_REPLY_DETAIL_NEXT_CLICKED, {stage, quizPercentage});
  }
  // [애착 유형 퀴즈 > 게스트가 보는 응답 디테일] 이전 버튼 클릭
  logAttachmentQuizGuestReplyDetailPrevClicked(stage: number, quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_GUEST_REPLY_DETAIL_PREV_CLICKED, {stage, quizPercentage});
  }
  // [애착 유형 퀴즈 > 게스트가 보는 응답 디테일] 다음 버튼 클릭
  logAttachmentQuizGuestReplyDetailNextClicked(stage: number, quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_GUEST_REPLY_DETAIL_NEXT_CLICKED, {stage, quizPercentage});
  }
  // [애착 유형 퀴즈 > 게스트가 보는 응답 디테일] 내 퀴즈 만들기 클릭
  logAttachmentQuizGuestReplyDetailMakeOwnClicked(quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_GUEST_REPLY_DETAIL_MAKE_OWN_CLICKED, {quizPercentage});
  }
  // [애착 유형 퀴즈 > 게스트가 보는 응답 디테일] 게스트 응답 상세로 이동
  logAttachmentQuizGuestReplyDetailViewed(quizPercentage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_GUEST_REPLY_DETAIL_VIEWED, {quizPercentage});
  }
  // [애착 유형 퀴즈 - 퀴즈 생성 Flow] 프로필 선택 / 이름 입력 화면 진입
  logAttachmentQuizCreateNameEntryViewed(): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_CREATE_NAME_ENTRY_VIEWED);
  }
  // [애착 유형 퀴즈 - 퀴즈 생성 Flow] 질문지 화면 조회
  logAttachmentQuizCreateQuestionnaireViewed(stage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_CREATE_QUESTIONNAIRE_VIEWED, {stage});
  }
  // [애착 유형 퀴즈 - 퀴즈 생성 Flow] 마지막 다음 버튼 클릭 (생성 요청)
  logAttachmentQuizCreateSubmit(): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_QUIZ_CREATE_SUBMIT);
  }
  // [애착 유형 퀴즈 - 응답 생성 Flow] 프로필 선택 / 이름 입력 화면 진입
  logAttachmentReplyCreateNameEntryViewed(): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_REPLY_CREATE_NAME_ENTRY_VIEWED);
  }
  // [애착 유형 퀴즈 - 응답 생성 Flow] pre_question 화면에서 ‘작성 완료’ 버튼 클릭 (생성 요청)
  logAttachmentReplyCreateSubmit(): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_REPLY_CREATE_SUBMIT);
  }
  // [애착 유형 퀴즈 -  응답 생성 Flow] 질문지 화면 진입
  logAttachmentReplyCreateQuestionnaireViewed(stage: number): void {
    this.eventLogging(AttachmentTypeLogEvent.ATTACHMENT_REPLY_CREATE_QUESTIONNAIRE_VIEWED, {stage});
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      category: 'attachment_test',
      ...params
    })
  }
}